// =============================================================================
// FILE: packages/renderer/src/config/feed.config.ts
// PURPOSE: Founder-controlled editorial + tech intelligence feed for the Dashboard.
//          Add new entries here to publish posts. No CMS needed.
//          Types: 'editorial' | 'tech_update' | 'partnership'
// =============================================================================

export type FeedPostType = 'editorial' | 'tech_update' | 'partnership';

export interface FeedPost {
  id:          string;
  type:        FeedPostType;
  title:       string;
  summary:     string;
  author:      string;
  date:        string;      // ISO date string e.g. '2026-07-01'
  tags?:       string[];
  link?:       string;      // external URL (optional)
  featured?:   boolean;     // pins to top of feed
  partnerName?: string;     // for 'partnership' type
  accentColor?: string;     // override card accent
}

// =============================================================================
// ── FOUNDER'S EDITORIAL & INTELLIGENCE FEED ──────────────────────────────────
// Add new posts at the TOP of this array so they appear first.
// =============================================================================

export const FEED_POSTS: FeedPost[] = [
  {
    id:        'editorial-001',
    type:      'editorial',
    featured:  true,
    title:     'The Founding Vision: Why BIM OPS Exists',
    summary:
      'Every major telecommunications project I\'ve worked on suffered from the same problem: ' +
      'too many spreadsheets, too many email threads, and not enough single sources of truth. ' +
      'BIM OPS is the platform I always needed — and now I\'m giving it to the industry.',
    author:    'John Bismonte, RCDD',
    date:      '2026-07-01',
    tags:      ['Vision', 'Founder', 'Mission'],
    accentColor: '#FCD34D',
  },
  {
    id:        'editorial-002',
    type:      'editorial',
    title:     'Introducing the Global Master Engine Tier',
    summary:
      'The Global Master Engine is built for firms that operate at the highest level — government ' +
      'contracts, multi-national projects, and enterprise bidding. This tier includes the Pursuit Agent, ' +
      'Executive Stationery, and direct access to the Founder for white-glove onboarding.',
    author:    'John Bismonte, RCDD',
    date:      '2026-07-01',
    tags:      ['Product', 'Enterprise', 'New Tier'],
    accentColor: '#F59E0B',
  },
  {
    id:        'tech-001',
    type:      'tech_update',
    title:     'Brand Agnostic Architecture: Switch Any Manufacturer in One Click',
    summary:
      'The new Hardware Parts Library and Global Brand Switcher allows Contractor and Enterprise ' +
      'users to switch the default manufacturer for any LV system — and automatically recalculate ' +
      'all specs, schedules, and diagrams. First live for Structured Cabling and Access Control.',
    author:    'RCD² Engine',
    date:      '2026-07-01',
    tags:      ['Feature', 'Parts Library', 'Brand Switcher'],
    accentColor: '#25B5A8',
  },
  {
    id:        'tech-002',
    type:      'tech_update',
    title:     'Emmy Now Has System Control: Ask Her to Change Your Settings',
    summary:
      'R² Emmy can now query your project database and execute UI preferences on command. ' +
      '"Turn off the warp effect" or "How many assets are in Project Alpha?" — Emmy executes ' +
      'and confirms every action professionally.',
    author:    'RCD² Engine',
    date:      '2026-06-30',
    tags:      ['Emmy', 'AI', 'System Control'],
    accentColor: '#818CF8',
  },
  {
    id:        'partnership-001',
    type:      'partnership',
    title:     'Founding Tech Partnership Opportunity — Open Now',
    summary:
      'RCD² is inviting select manufacturers to become Founding Technology Partners. ' +
      'Partners receive exclusive "Default Brand" status in BIM OPS for their category, ' +
      'co-branded presence in the Hardware Parts Library, and an Executive Feature Spotlight ' +
      'in this Intelligence Feed. Limited slots available per category.',
    author:    'John Bismonte, RCDD',
    date:      '2026-07-01',
    tags:      ['Partnership', 'Exclusive', 'Founding Partner'],
    link:      'mailto:rcd2engine@gmail.com?subject=Founding Tech Partner Inquiry',
    accentColor: '#34D399',
  },
];
